import { hasYesOrNo } from 'models/validate';
import cityCountry from 'forms/shared/validators/models/location/models/cityCountry';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { DateBaseValidatorOptions } from 'forms/shared/validators/base/date/types';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { CitizenshipForeignPassportItemModel } from '../types';
import { pvqForeignPassportInternationalValidator } from './pvqForeignPassportInternationalValidator';

export const pvqForeignPassportValidator: ValidateJSModel<CitizenshipForeignPassportItemModel> = {

  ForeignCountry: (value, attributes) => ({ hasValue: true, country: { excludeUnitedStates: true } }),

  Access: { presence: true, hasValue: { validator: hasYesOrNo } },

  IssueDate: (value, attributes, attributeName, options = {}) => {
    if (attributes.Access?.value === 'Yes') {
      const { applicantBirthdate } = options;
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }

    return {};
  },

  ExpirationDate: (value, attributes) => {
    if (attributes.Access?.value === 'Yes') {
      const dateLimits: DateBaseValidatorOptions = {};
      if (attributes?.IssueDate) {
        dateLimits.earliest = attributes?.IssueDate;
        dateLimits.tooEarly = 'error.passport.expiration.min';
      }
      return { presence: true, date: dateLimits };
    }

    return {};
  },

  IssueLocation: (value, attributes) => {
    if (attributes.Access?.value === 'Yes') {
      return {
        presence: true,
        location: { validator: cityCountry }
      };
    }

    return {};
  },

  NameUsed: (value, attributes) => {
    if (attributes.Access?.value === 'Yes') {
      return {
        presence: true,
        model: { validator: pvqNameModelValidator },
      };
    }

    return {};
  },

  DocumentNum: (value, attributes) => {
    if (attributes.Access?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  International: (value, attributes, attributeName, options) => ({
    presence: true,
    branchCollection: {
      validator: pvqForeignPassportInternationalValidator,
    },
  }),

  DocIntent: { presence: true, hasValue: { validator: hasYesOrNo } },

  DocIntentExplain: (value, attributes) => {
    if (attributes.DocIntent?.value === 'No') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  DocIntentIntl: { presence: true, hasValue: { validator: hasYesOrNo } },

  DocIntentIntlExplain: (value, attributes) => {
    if (attributes.DocIntentIntl?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

};
